var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgRedBike = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23.356,
    height: 12.042,
    viewBox: "0 0 23.356 12.042",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.977,89.357a4.357,4.357,0,0,0-1.473.256l-1.2-2.238v0l-.513-.953a.657.657,0,0,0-.579-.346h-.822a.657.657,0,0,0,0,1.314h.338L9.771,89.508l-.665-1.173a.657.657,0,0,0-.011-1.314H7.386a.657.657,0,1,0,0,1.314h.262a.655.655,0,0,0,.078.231L8.851,90.55l.067.608-.793.312a4.379,4.379,0,1,0,.389,3.707l1.407.25a.657.657,0,0,0,.628-.237l5.059-6.326.738,1.372a4.377,4.377,0,1,0,2.629-.88ZM4.379,96.8a3.065,3.065,0,1,1,2.5-4.839L3.925,93.125a.657.657,0,0,0,.126,1.259l3.146.559A3.069,3.069,0,0,1,4.379,96.8Zm3.012-3.63a3.071,3.071,0,0,1,.051.48L6.569,93.5Zm1.239-.488.438-.172.161,1.458-.474-.084c0-.049,0-.1,0-.148A4.375,4.375,0,0,0,8.63,92.684Zm1.835.508L10.2,90.756l3.372-1.443ZM18.977,96.8a3.063,3.063,0,0,1-2-5.388L18.4,94.048a.657.657,0,1,0,1.157-.623L18.137,90.79a3.065,3.065,0,1,1,.84,6.012Z",
    transform: "translate(0 -86.074)",
    fill: "red"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRedBike, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/red-bike.43e24d4b.svg";
export { ForwardRef as ReactComponent };